<template>
  <div class="time-ctr" ref="container">
    <div class="input age" @click="show = !show">
      {{ currentAge.label }}
      <img src="/images/expand_more.svg" />
      <!-- <span class="material-symbols-outlined">expand_more</span> -->
    </div>

    <div class="dropdown" v-show="show">
      <div class="wrap" ref="wrap">
        <VueSlickCarousel ref="carousel" v-bind="settings">
          <article
            v-for="(data, idx) in ageOptions"
            :key="idx"
            @click="changeAge(idx)"
            :class="{clicked: currentAge.value === data.value}"
          >
            {{ data.label }}
          </article>
        </VueSlickCarousel>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  components: {VueSlickCarousel},

  props: {
    age: null,
  },

  emits: ['new-age'],

  data: () => ({
    settings: {
      'dots': false,
      'arrows': false,
      'edgeFriction': 0.35,
      'infinite': false,
      'speed': 500,
      'slidesToShow': 9,
      'slidesToScroll': 1,
      'vertical': true,
      'draggable': true,
    },
    currentAge: {
      label: '26+ Years',
      value: '26',
      idx: 8,
    },
    show: false,
    ageOptions: [
      // {
      //   label: '18 Years',
      //   value: '1',
      // },
      {
        label: '19 Years',
        value: '2',
      },
      {
        label: '20 Years',
        value: '3',
      },
      {
        label: '21 Years',
        value: '4',
      },
      {
        label: '22 Years',
        value: '5',
      },
      {
        label: '23 Years',
        value: '6',
      },
      {
        label: '24 Years',
        value: '7',
      },
      {
        label: '25 Years',
        value: '8',
      },
      {
        label: '26+ Years',
        value: '9',
      },
    ]
  }),

  mounted() {
    // if (this.age != null) {
    //   const ageIdx = this.ageOptions.findIndex((_, idx) => (idx + 1) === this.age)
    //   console.log('passed age: ', this.age)
    //   console.log('index: ',ageIdx)

    //   if (ageIdx >= 0) this.changeAge(ageIdx)
    // }

    this.$refs.carousel?.goTo(5)
    document.body.addEventListener('click', this.isClickOutside)
  },

  destroyed() {
    document.body.removeEventListener('click', this.isClickOutside)
  },

  watch: {
    currentAge(newAge) {
      this.$emit('new-age', Number(newAge.idx) + 2)
      this.$refs.carousel?.goTo(18)
    },

    age: function (propAge) {
      const ageIdx = this.ageOptions?.findIndex((val) => Number(val.value) === propAge)
      if (propAge != null && ageIdx >= 0) {
        this.changeAge(ageIdx)
      }
    }
  },

  methods: {
    changeAge(newAge) {
      this.currentAge = {...this.ageOptions[newAge], idx: newAge}
      this.show = false
    },

    isClickOutside(e) {
      if (e?.target === this.$refs.container || this.$refs.container?.contains(e?.target)) {
        return
      }

      this.show = false
    },
  }
}
</script>

<style lang="scss" scoped>
.time-ctr {
  position: relative;
  width: 100%;

  div.input {
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    padding-right: 0 !important;

    width: 100%;
    height: 44px;

    @media (min-width: 1281px) {
      width: 100px;
    }

    span.material-symbols-outlined {
      margin-left: 0 !important;
      padding: 0 5px 0 0 !important;
    }
  }

  div.dropdown {
    position: absolute;
    top: calc(100% + 3px);
    left: 0;
    z-index: 9999;
    border-radius: 3px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    width: inherit;

    @media (min-width: 1281px) {
      width: 100px;
    }

    .wrap {
      overflow: hidden;
      max-height: 281px !important;
      padding-top: 4px;
      border: solid 1px #E4E7ED;

      width: inherit;

      background-color: white;
      border-radius: 4px;

      &::-webkit-scrollbar {
        display: none;
      }

      .slick-slider.slick-initialized.slick-vertical {
        .slick-list {
          .slick-track {
            height: auto !important;
          }
        }
      }

      .slick-track {
        height: auto !important;
      }

      .slick-slide {
        border: none !important;
        margin-left: -1px !important;
      }

      article {
        display: flex !important;
        align-items: center;
        height: 34px;
        padding-left: 11px;
        font-weight: 400;
        font-size: 12.5px;
        letter-spacing: 0.09px;
        line-height: 1.76;
        border: none;
        border: none;
        margin-bottom: -2px;
        width: 103% !important;

        &:hover, &.clicked {
          background-color: #EC1C24;
          color: white;
        }
      }
    }
  }
}
</style>
